import axios from "axios";

// Configure global axios defaults
const setupAxios = () => {
  const token = document.querySelector("[name=csrf-token]")?.content;

  if (token) {
    axios.defaults.headers.common["X-CSRF-TOKEN"] = token;
  }

  // Set default headers for JSON API requests
  axios.defaults.headers.common["Content-Type"] = "application/json";
  axios.defaults.headers.common["Accept"] = "application/json";

  // Optional: Add response interceptors for handling errors globally
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      // Handle global errors here (e.g., show toast notification)
      console.error("API request error:", error);
      return Promise.reject(error);
    }
  );
};

export default setupAxios;
